import { useGetIdentity } from "ra-core";
import { CreateSheet } from "../misc/CreateSheet";
import { CompanyInputs } from "./CompanyInputs";
export function CompanyCreateSheet({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const { identity } = useGetIdentity();
  return (
    <CreateSheet
      resource="companies"
      title="Новая компания"
      open={open}
      onOpenChange={onOpenChange}
      defaultValues={{ sales_id: identity?.id }}
      transform={(values) => ({
        ...values,
        website:
          values.website && !values.website.startsWith("http")
            ? `https://${values.website}`
            : values.website,
      })}
    >
      <CompanyInputs />
    </CreateSheet>
  );
}
